// import * as common from '@/store/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const COMP_LIST = 'COMP_LIST';
export const STATE_INIT = 'STATE_INIT';
export const PAGING_INFO = 'PAGING_INFO';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const CMPN_MST_POPUP = 'CMPN_MST_POPUP';

export default {
	// ...common,
	SEARCH_PARAM,
	COMP_LIST,
	PAGING_INFO,
	DEFAULT_ASSIGN,
	STATE_INIT,
	CMPN_MST_POPUP
};
